module.exports = __webpack_public_path__ + "static/img/8-1.0150cf4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/8-1.jpg
// module id = WYwq
// module chunks = 0